import { render, staticRenderFns } from "./TermsAndConditionsPage.be-nl.vue?vue&type=template&id=09990e84"
import script from "./TermsAndConditionsPage.be-nl.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsPage.be-nl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports